<template>
    <div data-app class="v-application v-application--is-ltr theme--light" style="background-color: inherit;display:block">
        <router-view></router-view>
    </div>
</template>

<script>
import Vue from "vue";
import {asset} from "@codinglabs/laravel-asset";

export default {
};
</script>
